import { z } from "zod";
import { common } from "../common";
import { conversionGetBaseSchema } from "./conversionGetBaseSchema";

export const openedEmailFromSameCampaignConversionGetSchema = z.object({
  ...conversionGetBaseSchema.shape,
  event_type: z.literal("TrackedUserBehavior::OpenedEmailFromSameCampaign"),
  interaction: z.literal("oe"),
  selected_campaign_id: common.objectId.nullable(),
  selected_campaign_name: z.string().nullable(),
  selected_carousel_slide_id: z.string().nullable(),
  selected_carousel_slide_name: z.string().nullable(),
  selected_push_button_name: z.string().nullable(),
  selected_push_button_string: z.string().nullable(),
});
